<template>
  <div>
    <v-card class="mx-auto mt-4" max-width="98%" elevation="2">
      <v-toolbar color="#5D4037" dark flat>
        <v-icon left>mdi-gold</v-icon>
        <v-toolbar-title>금교환 관리</v-toolbar-title>
      </v-toolbar>
      <v-tabs
        v-model="activeTab"
        background-color="#6D4C41"
        dark
        show-arrows
        slider-color="amber accent-2"
      >
        <v-tab><v-icon left small>mdi-gold</v-icon>금교환 관리</v-tab>
        <v-tab><v-icon left small>mdi-atom</v-icon>상품관리</v-tab>
      </v-tabs>
    </v-card>

    <!-- v-tab-item 은 기본 지연 렌더링 → 탭을 처음 열 때 각 컴포넌트의 created() 가 실행된다 -->
    <v-tabs-items v-model="activeTab">
      <v-tab-item><GoldOrderList /></v-tab-item>
      <v-tab-item><CoinProduct /></v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
// 금교환 관리 + 상품관리를 탭으로 통합 — 각 컴포넌트는 수정 없이 그대로 재사용
import GoldOrderList from './Game_GoldOrderList.vue';
import CoinProduct from './Game_CoinProduct.vue';

export default {
  name: 'CarryGold_GoldExchange',
  components: { GoldOrderList, CoinProduct },
  data: () => ({
    activeTab: 0,
  }),
};
</script>
